var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "adminroletree" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.handleAddTop } },
                [_vm._v("添加顶级角色")]
              ),
              _vm._v(" "),
              _c("el-tree", {
                attrs: {
                  data: _vm.tree,
                  props: _vm.defaultProps,
                  "node-key": "id",
                  "highlight-current": "",
                  "expand-on-click-node": false,
                  "default-expanded-keys": _vm.expanded,
                  "render-content": _vm.renderContent
                },
                on: { "node-click": _vm.handleNodeClick }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              attrs: { span: 12 }
            },
            [
              _vm._v("\n      关联权限管理\n      "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.submitMca()
                    }
                  }
                },
                [_vm._v("提交")]
              ),
              _vm._v(" "),
              _c("el-tree", {
                ref: "mcaTree",
                attrs: {
                  data: _vm.mcaTree,
                  "node-key": "id",
                  "show-checkbox": "",
                  "default-checked-keys": _vm.mcaChecked,
                  "default-expanded-keys": _vm.mcaExpanded
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c("span", { staticClass: "custom-tree-node" }, [
                        _c("span", [_vm._v(_vm._s(node.label) + " ")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(data.id) + " ")])
                      ])
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.submitMca()
                    }
                  }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bf7102f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bf7102f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AdminRoleTree.vue
// module id = null
// module chunks = 